import { Navigate } from 'react-router-dom'

import { canViewAccountingReport } from '@blocktickets/shared-utils'

import AuthService from '../../utilities/services/auth.service'
import { AccountingReportWrapper } from '../../components'

const isSuperAdminUser = (organization) => {
  const currentUser = AuthService.getUser()?.user
  return Boolean(
    currentUser?.superAdmin ||
    AuthService.isSuperAdminOrganizer() ||
    organization?.members?.some(
      (member) => member?.uuid === currentUser?.uuid && member?.superAdmin
    )
  )
}

export default function AccountingReportPage() {
  const organization = AuthService.getOrg()?.[0]

  if (
    !canViewAccountingReport({
      organization,
      isSuperAdmin: isSuperAdminUser(organization),
    })
  ) {
    return <Navigate to="/" replace />
  }

  return <AccountingReportWrapper organization={organization} />
}
